import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/_auth/_main/campaigns/$campaignId/settings/notifications')({
    beforeLoad: ({ params }) => {
        throw redirect({
            to: '/campaigns/$campaignId/settings',
            params,
            hash: 'notifications',
        })
    },
})
